import { Component, OnInit, ViewChild } from '@angular/core';
import { TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';

@Component({
    selector: 'app-solicitacao-honra-lote-pesquisa',
    templateUrl: './solicitacao-honra-lote-pesquisa.component.html',
    standalone: false
})
export class SolicitacaoHonraLotePesquisaComponent {

  textoBotaoEnvio = 'Enviar arquivo de solicitações de honra';
  tooltipBotaoEnvio = 'Selecione esta opção para enviar um arquivo com solicitações de honra';
  tiposConteudo: TipoConteudo[] = [TipoConteudo.SOLICITACOES_HONRA];
  incluirCampoJanelaEnvio = true;
}


